import { InheritedSpan } from 'src/pages/contribute/styles';
import { Box, Stack } from '@mui/material';
import MakingBetterImg from 'src/assets/images/MakingBetter.png';
import RefreshIcon from 'src/assets/icons/Refresh.svg';
import { Dialog, RefreshButton, SubTitle, Title } from './MakingBetter.styles';

const MakingBetter = ({ open }: { open: boolean }) => (
  <Dialog open={open}>
    <Box sx={{ flex: '0.4' }}>
      <Box
        component={'img'}
        src={MakingBetterImg}
        sx={{ width: { md: '315px', xs: '200px' }, height: 'auto' }}
      />
    </Box>
    <Stack
      sx={{
        flex: '0.6',
        gap: { md: '16px', xs: '24px' },
        alignItems: 'center',
      }}
    >
      <Stack sx={{ gap: { md: '16px', xs: '8px' } }}>
        <Title>{`🛠️ We're Making Things Even Better!`}</Title>
        <SubTitle>{`Our developers are working behind the scenes to enhance your experience. We'll be back shortly—thanks for your patience!`}</SubTitle>
      </Stack>
      <RefreshButton onClick={() => location.reload()}>
        <Box
          component={'img'}
          src={RefreshIcon}
          sx={{ width: '24px', height: '24px' }}
        />
        <InheritedSpan>Refresh Page</InheritedSpan>
      </RefreshButton>
    </Stack>
  </Dialog>
);

export default MakingBetter;
